var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_adults") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_adults",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(5, 10)",
    fill: "#252C48",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-2",
    transform: "translate(17, 6.2357)",
    fillOpacity: 0.2,
    stroke: "#252C48",
    strokeOpacity: 0.2,
    strokeWidth: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1161229,7.44189034 C11.8062906,5.72775318 11.792848,2.9707856 10.0860451,1.27319383 C8.37924214,-0.424397943 5.62075786,-0.424397943 3.91395494,1.27319383 C2.20715202,2.9707856 2.19370939,5.72775318 3.88387715,7.44189034 C1.54526808,8.36071256 0.0054735352,10.6140141 0,13.1254706 C0,13.3574505 0.0920134632,13.5799669 0.256136335,13.7440015 C0.420259207,13.908036 0.642895369,14 0.875000123,14 L13.1249999,14 C13.3571046,14 13.5797408,13.908036 13.7438637,13.7440015 C13.9079865,13.5799669 14,13.3574505 14,13.1254706 C13.9945265,10.6140141 12.4547319,8.36071256 10.1161229,7.44189034 Z M7,1.75659017 C8.44974744,1.75659017 9.62499995,2.93121044 9.62499995,4.38017796 C9.62499995,5.82914549 8.44974744,7.00376575 7,7.00376575 C5.55025256,7.00376575 4.37500005,5.82914549 4.37500005,4.38017796 C4.37660747,2.93187641 5.5509189,1.75819672 7,1.75659017 Z M1.83716469,12.2509413 C2.25624802,10.2165585 4.04682956,8.75575986 6.12500002,8.75282428 L7.87499998,8.75282428 C9.95317044,8.75575986 11.743752,10.2165585 12.1628353,12.2509413 L1.83716469,12.2509413 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.8226589,10.9160381 C17.2991789,8.40167877 17.2794821,4.35765745 14.7785874,1.86756748 C12.2776928,-0.622522493 8.23582096,-0.622522493 5.73492631,1.86756748 C3.23403166,4.35765745 3.21433483,8.40167877 5.6908548,10.9160381 C2.26420557,12.2638003 0.00802010282,15.5690257 0,19.2529224 C0,19.5931991 0.134822817,19.9195943 0.375304016,20.1602062 C0.615785216,20.4008182 0.94200307,20.5357143 1.28209479,20.5357143 L19.2314189,20.5357143 C19.5715107,20.5357143 19.8977285,20.4008182 20.1382097,20.1602062 C20.3786909,19.9195943 20.5135137,19.5931991 20.5135137,19.2529224 C20.5054936,15.5690257 18.2493082,12.2638003 14.8226589,10.9160381 Z M10.2567569,2.57663099 C12.3810007,2.57663099 14.1030406,4.29960715 14.1030406,6.42500594 C14.1030406,8.55040474 12.3810007,10.2733809 10.2567569,10.2733809 C8.13251301,10.2733809 6.41047312,8.55040474 6.41047312,6.42500594 C6.41282838,4.30058402 8.13348935,2.57898754 10.2567569,2.57663099 Z M2.69190736,17.9701308 C3.30596962,14.9860232 5.92962098,12.8432702 8.97466228,12.8389642 L11.5388514,12.8389642 C14.5838927,12.8432702 17.2075441,14.9860232 17.8216064,17.9701308 L2.69190736,17.9701308 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdults);
export default __webpack_public_path__ + "static/media/adults.34122c67f7d0cf816af6eb6a90865602.svg";
export { ForwardRef as ReactComponent };